export default "__VITE_ASSET__DDuH3lNn__"